import { Component, OnInit } from '@angular/core';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.scss'],
})
export class FaqPageComponent implements OnInit {
  productCode = ProductCode;
  constructor() {}

  ngOnInit() {}
}
